import mixpanelUtils from '@/utils/mixpanel.utils'

const setPresentation = (state, payload) => {
  if (!payload.language) {
    payload.language = 'en'
  }
  state.presentation = payload
}

const updatePresentation = (state, payload) => {
  if (!payload.language) {
    payload.language = 'en'
  } else if (!payload.fontFamily) {
    payload.fontFamily = 'nunito'
  }
  state.presentation = { ...state.presentation, ...payload }
}

const unsetPresentation = () => {
  mixpanelUtils.unregisterPresentationContext()
}

const setIsCreatingNewPresentation = (state, payload) => {
  state.isCreatingNewPresentation = payload
}

const setMorePresentationsLoading = (state, payload) => {
  state.loaders.morePresentationsLoading = payload
}

const setQRCodeVisible = (state, payload) => {
  state.isQRCodeVisible = payload
}

const setIsOpeningPrivateFeedback = (state, payload) => {
  state.isOpeningPrivateFeedback = payload
}

const setPresentFromBeginning = (state, payload) => {
  state.presentIsBeginning = payload
}

const addSlides = (state, payload) => {
  const { slidesToAdd, insertAfter } = payload

  const newSlides = [...state.presentation.slides]
  newSlides.splice(insertAfter + 1, 0, ...slidesToAdd)

  state.presentation.slides = newSlides
}

export default {
  setPresentation,
  updatePresentation,
  unsetPresentation,
  setIsCreatingNewPresentation,
  setMorePresentationsLoading,
  setQRCodeVisible,
  setIsOpeningPrivateFeedback,
  setPresentFromBeginning,
  addSlides,
}
